import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import { IconCode, IconGraph, IconRocket } from '@posthog/icons';
import OSButton from 'components/OSButton';
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  QuestLog,
  QuestLogItem,
  IconCode,
  IconGraph,
  IconRocket,
  OSButton,
  CalloutBox,
  React
};